﻿import { global, getRelativeSiteURL, getSiteAbsoluteURL, isEmpty, isUnDefined } from "../Common/saop-common";
import { SaopViewForm } from "../Core/saop-view-form";
import { SaopFloatingLabel } from '../Components/saop-floating-label';


export class RegAbsenceCancelRequest extends SaopViewForm {
  private _formId:string;

  constructor(viewId:string,libName:string = ""){
    super(viewId,libName);
    this.setDictionary();  
    this.title = this.translationService.translate("Prekliči odsotnost");
    this.fullTitle = this.title;
    this.addRecordEndpoint = "";
    this.editRecordEndpoint = "REGAbsence/MyAbsencesCancelRequest";
    this.deleteRecordEndpoint = ""; 
    //
    this.afterViewShowSuccess = this.initView;
    //this.onBtnOkClick = this.onConfirmClick.bind(this);
    //
  }

  setDictionary(){
      let dictionary:string[] = ["Prekliči odsotnost"];
      this.setTerminologyList(dictionary);
  } 


  public initView():void{
    this.LoadViewEvents();
  }

  public LoadViewEvents ():void{
    let _viewDiv = $(this.id);
    if (_viewDiv.length == 0) {return;}

    let _this = this;
    this._formId = "#MyAbsencesCancelRequest";

    // $(this._formId).find("#btnCancelRequest").off("click");
    // $(this._formId).find("#btnCancelRequest").on('click', function(row){
    //   _this.onConfirmClick();
    // });       
  }

  public onConfirmClick (): void {
    global.ConsoleLogDegug(this._formId+".onCancelRequest");    

    let _reason = $(this._formId).find("#Reason option:selected").val();
    let _reasonDescription =  $(this._formId).find("#ReasonDescription").val();


    this.CloseViewForm();
    // $("#regKeZapDopustiView1").find("#desktopKomentar").val(_komentarText);
    // $("#regKeZapDopustiView1").find("#mobileKomentar").val(_komentarText);            
    // $("#regKeZapDopustiView1").find("#Status").val(0);
    // $("#regKeZapDopustiView1").submit(); 
  }

  public onSubmitSuccessComplete(response: any): void {
    if (response.viewContent) {
        alertify.message(response.viewContent);
    }  
}

  //
}

